// packages/web/src/routes/AdminRoutes.tsx
import React from 'react';
import PromoCodeAdmin from '../components/admin/PromoCodeAdmin';

interface AdminRoutesProps {
  isAdmin: boolean;
}

const AdminRoutes: React.FC<AdminRoutesProps> = ({ isAdmin }) => {
  // If not admin, redirect or show access denied
  if (!isAdmin) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-100">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
          <h1 className="text-2xl font-bold text-red-600 mb-4">Access Denied</h1>
          <p className="text-gray-700 mb-4">
            You do not have permission to access this area. This section is restricted to administrators only.
          </p>
          <a 
            href="/"
            className="block w-full text-center bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded"
          >
            Return to Home
          </a>
        </div>
      </div>
    );
  }

  // Admin is authenticated, show admin dashboard
  return <PromoCodeAdmin />;
};

export default AdminRoutes;